<div class="title">
  <mat-icon>groups_2</mat-icon>
  Department
</div>
<div class="description">SELECT THE DEPARTMENTS TO FILTER BY</div>

<div class="options">
  <elements-filter-chip
    icon="groups_2"
    [caption]="getDisplayName(department)"
    [selected]="isSelected(department)"
    *ngFor="let department of allDepartments"
    (click)="isSelected(department) ? removeProduct(department) : addProduct(department)"
    [suffixIcon]="isSelected(department) ? 'close' : undefined"
  >
  </elements-filter-chip>
</div>

<div class="actions">
  <button styles-button (click)="close.emit()">Filter</button>
  <button styles-low-button (click)="clear()">Clear</button>
</div>
